// Actions
export const setStoredWorkordersAction = () => dispatch => dispatch({
    type: WORKORDERS_STORED.SET
})
// Reducer response
export const WORKORDERS_STORED = {
  SET: 'WORKORDERS_STORED_SET',
  setResponse: ({ state }) => {
    // Going offline shows the stored cache, but the cache drifts behind `items` (the
    // sync lifecycle and off-detail edits only touch items). Prefer the live items
    // copy of each stored workorder, and keep any unsynced items-only workorder, so
    // the switch never reverts a synced result or drops offline work.
    const merged = state.stored_workorders.map(stored =>
      state.items.find(item => item.id == stored.id) || stored
    )
    const extras = state.items.filter(item =>
      (item.error || item.syncing || !item.synced) &&
      !state.stored_workorders.some(stored => stored.id == item.id)
    )
    const items = [...merged, ...extras]

    return {
      ...state,
      items,
      loading:       false,
      loadingNext:   false,
      total_entries: items.length,
      total_pages:   1
    }
  }
}
